import { EChartsOption } from "echarts";
import { Box, Container } from "@mui/material";
import { RopChart } from "../../../../main/components/RopChart";
import { EmptyTable } from "../../../clients/components/EmptyState";
import { RelatorioParcialPareto } from "../../types";

export default function ParetoRelatorioParcialChart(props: {
    data: RelatorioParcialPareto,
    title: string,
    serieTitle: string,
    yAxisNameList?: string[],
}) {
    const { data, title, serieTitle, yAxisNameList } = props

    const hasData = Object.keys(data.items).length > 0

    const eventosQntdColor = "#ee7d00";
    const porcentagemColor = "#1A0144";

    const reversedItems = [...data.items].reverse();

    const percentageValues = reversedItems.map((item, index) => {
        const previousValues = reversedItems.slice(0, index);
        const previousPercentageSum = previousValues.reduce(
            (acc, item) => acc + item.percentage,
            0
        );
        return (item.percentage + previousPercentageSum).toFixed(2);
    });
    const alarmValues = reversedItems.map((item) => item.value);
    const xLabels = reversedItems.map((item) => item.usinaCode);
    const legendData = [serieTitle, "Porcentagem"];

    const sortedAlarmValues = [...alarmValues].sort((a, b) => b - a);
    const maxValue = sortedAlarmValues[0];
    const secondMaxValue = sortedAlarmValues[1];

    const outlierThreshold = 10;
    if (maxValue >= outlierThreshold * secondMaxValue) {
        const maxIndex = alarmValues.indexOf(maxValue);
        alarmValues.splice(maxIndex, 1);
    }

    const options: EChartsOption = {
        title: {
            text: title,
            textStyle: {
                fontSize: 12,
            },
        },
        grid: {
            left: 0,
            right: 0,
            bottom: 0,
            containLabel: true,
        },
        backgroundColor: "transparent",
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "cross",
                crossStyle: {
                    color: "#999",
                },
            },
            confine: true,
        },

        legend: {
            data: legendData,
            left: "right",
        },
        xAxis: [
            {
                type: "category",
                data: xLabels,
                axisPointer: {
                    type: "shadow",
                },
                axisLabel: {
                    fontSize: 10,
                    rotate: 65,
                    interval: 0
                },
                axisTick: {
                    alignWithLabel: true,
                },
            },
        ],
        yAxis: [
            {
                type: "value",
                name: yAxisNameList && yAxisNameList?.length > 0 ? (yAxisNameList[0] ?? "") : "(%)",
            },
            {
                type: "value",
                name: yAxisNameList && yAxisNameList?.length > 1 ? (yAxisNameList[1] ?? "") : "Acumulado",
                axisLabel: {
                    formatter: title === "Pareto de Performance Ratio" ? "{value}" : "{value} %",
                },
            },
        ],
        series: [
            {
                name: serieTitle,
                type: "bar",
                tooltip: {
                    valueFormatter: function (value) {
                        let vPtBr: string;
                        if (typeof value !== "number") {
                            vPtBr = `${value}`;
                        } else {
                            vPtBr = value.toLocaleString("pt-BR", {
                                minimumFractionDigits: 4,
                                maximumFractionDigits: 4,
                            });
                        }
                        return title === "Pareto de Performance Ratio" ? vPtBr : `${vPtBr} %`;
                    },
                },
                data: alarmValues,
                itemStyle: {
                    color: eventosQntdColor,
                },
            },
            {
                name: "Porcentagem",
                yAxisIndex: 1,
                type: "line",
                tooltip: {
                    valueFormatter: function (value) {
                        let vPtBr: string;
                        if (typeof value !== "number") {
                            vPtBr = `${value}`;
                        } else {
                            vPtBr = value.toLocaleString("pt-BR", {
                                minimumFractionDigits: 4,
                                maximumFractionDigits: 4,
                            });
                        }
                        return `${vPtBr} %`;
                    },
                },
                data: percentageValues,
                itemStyle: {
                    color: porcentagemColor,
                },
            },
        ],
    }

    return (
        <>
            {hasData ? (
                <Container
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        height: "90%",
                        width: "100%",
                    }}
                >
                    <RopChart option={options} />
                </Container>
            ) : (
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <EmptyTable title="Nenhum dado encontrado!" />
                </Box>
            )}
        </>
    );
}
